import { Component, inject, signal } from '@angular/core';
import {
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { AxiosError } from 'axios';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { HeaderEmptyComponent } from '../../components/headers/header-empty/header-empty.component';
import { FormTemplateComponent } from '../../shared/screen-templates/form-template/form-template.component';
import { PayeeOtpFormFieldComponent } from '../../shared/payee-form-fields/payee-otp-form-field/payee-otp-form-field.component';
import { PayeeButtonComponent } from '../../shared/payee-buttons/payee-button/payee-button.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-twofa-form',
  templateUrl: './twofa-form.component.html',
  styleUrls: ['./twofa-form.component.scss'],
  imports: [
    HeaderEmptyComponent,
    FormTemplateComponent,
    FormsModule,
    ReactiveFormsModule,
    PayeeOtpFormFieldComponent,
    PayeeButtonComponent,
    MatProgressSpinner,
    TranslateModule,
  ],
})
export class TwofaFormComponent {
  private fb = inject(FormBuilder);
  private authService = inject(AuthService);

  readonly twofaForm = this.fb.group({
    code: this.fb.control('', {
      validators: [Validators.required, Validators.pattern(/^\d{6}$/)],
      nonNullable: true,
    }),
  });

  readonly loading = signal(false);

  get code() {
    return this.twofaForm.controls.code;
  }

  readonly submitToken = async (): Promise<void> => {
    if (this.twofaForm.invalid) {
      this.twofaForm.markAllAsTouched();
      return;
    }

    const { code } = this.twofaForm.getRawValue();

    try {
      this.loading.set(true);
      await this.authService.submitMFACode(code);
    } catch (error) {
      if (error instanceof AxiosError && error.response?.status === 422) {
        this.code.setErrors({ invalidCode: true });
      }
    } finally {
      this.loading.set(false);
    }
  };
}
